import {
    CHANGE_USERNAME_OPEN_MODAL,
    CHANGE_USERNAME_CLOSE_MODAL,
    CHANGE_USERNAME_UPDATE_REQUEST,
    CHANGE_USERNAME_UPDATE_RESULT,
    CLEAR_REDUX,
} from 'Redux/actionTypes';

const INIT_STATE = {
    loading: false,
    openModal: false,
    result: null,
    error: null,
    data: null,
    device: null,
    simDetails: null,
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case CHANGE_USERNAME_OPEN_MODAL:
            return { ...state, openModal: true, data: action.payload }

        case CHANGE_USERNAME_CLOSE_MODAL:
            return { ...state, openModal: false, data: null }

        case CHANGE_USERNAME_UPDATE_REQUEST:
            return { ...state, loading: true }

        case CHANGE_USERNAME_UPDATE_RESULT:
            return { ...state, loading: false, result: action.payload }

        case CLEAR_REDUX:
            return ["", "CHANGE_USERNAME"].includes(action.payload.option)
                ? action.payload.parameters ? { ...state, ...action.payload.parameters } : { ...INIT_STATE }
                : { ...state }
        default:
            return state;
    }
};